import Button from 'components/Button';
import { PropsWithChildren } from 'react';
import Text from 'components/Text';
import { TEXT_STRING } from '../../constants';

const lineStr = TEXT_STRING.LINE;

type Props = PropsWithChildren<{
  onCancel: () => void;
  onClick: () => void;
  loading?: boolean;
  disabled?: boolean;
}>;

function LineLoginModalContent({
  onCancel,
  onClick,
  loading = false,
  disabled = false,
}: Props) {
  return (
    <div className="bg-white flex flex-col gap-4 items-center justify-center">
      <div className="text-center">
        <Text center fontSize={16} bold>
          {lineStr.CONFIRM_LOGIN_TITLE}
        </Text>
      </div>
      <Button
        onClick={onClick}
        block
        bgColor="bg-line"
        bold
        textSize="text-sm"
        loading={loading}
        disabled={disabled}
        iconLeft="line"
      >
        {lineStr.LOGIN}
      </Button>
      {onCancel && (
        <Text
          onClick={onCancel}
          className="underline cursor-pointer"
          textColor="text-neutral"
          fontSize={14}
          bold
        >
          {TEXT_STRING.COMMON.CANCEL}
        </Text>
      )}
    </div>
  );
}

export default LineLoginModalContent;
